<template>
  <v-autocomplete
    :autocomplete="autocomplete"
    placeholder="Commencer à saisir pour lancer la recherche"
    v-model="nationalite"
    :loading="loading"
    :search-input.sync="recherche"
    :items="nationalites"
    no-filter
    v-bind="$attrs"
    v-on="$listeners"
    :data-testid="dataTestid"
  />
</template>

<script>
import _ from "lodash";
import { nationaliteService } from "@/services";
export default {
  props: {
    "data-testid": {
      type: String,
      required: false,
    },
    value: {
      type: String,
      required: false,
    },
  },

  data() {
    return {
      loading: false,
      items: [],
      recherche: null,
      default: ["FRANÇAISE"],
      nationalite: this.value,
      autocomplete: Math.random().toString(36).slice(2) // Génère une chaîne aléatoire pour bloquer l'autocomplete des navigateurs
    };
  },

  mounted() {
    this.debouncedQuery = _.debounce(this.query.bind(this), 250);
  },

  methods: {
    query(recherche) {
      this.loading = true;
      nationaliteService
        .autocomplete(recherche)
        .then(items => {
          this.items = items;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    demarreRecherche() {
      this.debouncedQuery(this.recherche);
    },
  },

  watch: {
    recherche() {
      this.demarreRecherche();
    },
    value() {
      this.nationalite = this.value;
    },
    nationalite() {
      if (this.value !== this.nationalite) {
        this.$emit("input", this.nationalite);
      }
    },
  },

  computed: {
    nationalites() {
      const nationalites = this.recherche ? [...this.items] : [...this.default];
      if (this.value && nationalites.findIndex(c => c === this.value) < 0) {
        nationalites.push(this.value);
      }
      return nationalites;
    },
  }
};
</script>

